const system_limit = {
    limit_exceeded: 'Вы достигли системного лимита. Пожалуйста, обратитесь в службу поддержки за помощью.',
};
export default Object.freeze(system_limit);
